import angular from 'angular';

import { ContrachequesIndexController } from './index/contracheques.index.controller';
import { ConfiguracoesService } from '../../Configuracoes/configuracoes.service';

import { ContrachequesListRouting } from './contracheques.routes';

export const ContrachequesModule = angular.module('ContrachequesModule', ['ui.router.state', ])
    .controller('ContrachequesIndexController', ContrachequesIndexController )
    .service('ConfiguracoesService', ConfiguracoesService)
    .config(ContrachequesListRouting)
    .name;
